<!--
 * @Author: yihao yihao@meiomedical.com
 * @Date: 2025-08-14 17:30:45
 * @LastEditors: yihao yihao@meiomedical.com
 * @LastEditTime: 2025-10-22 20:01:55
 * @FilePath: \website_vue1\src\views\productDetail.vue
 * @Description: 这是默认设置,请设置`customMade`, 打开koroFileHeader查看配置 进行设置: https://github.com/OBKoro1/koro1FileHeader/wiki/%E9%85%8D%E7%BD%AE
-->
<template>
  <div>
    <!-- 固定头部导航 -->
    <nav class="anchor-navbar" ref="anchorNavbar">
      <ul class="anchor-list">
        <!-- 第一项展示，不作为锚点 -->
        <!-- <li class="display-only">{{ sections[0].label }}</li> -->

        <!-- 其他可点击锚点 -->
        <li
          v-for="(item, index) in sections.slice(1)"
          :key="index + 1"
          :class="{ active: activeSection === item.id }"
          @click="scrollToSection(item,index)"
        >{{ item.label }}</li>
      </ul>
    </nav>

    <!-- 页面内容 -->
    <section class="anchor-section" ref="anchorSection">
      <!-- 第一屏的内容 -->
      <template>
        <div class="video" ref="videoSection">
          <video
            v-if="!isMobile"
            src="@/assets/videos/productDetail.mp4"
            muted
            playsinline
            class="bg-video"
            ref="bgVideo"
            poster="../assets/images/product/videoBg.jpg"
          ></video>

          <video
            v-if="isMobile"
            src="@/assets/videos/productDetail-mobile.mp4"
            muted
            playsinline
            class="bg-video-mobile"
            ref="bgVideo"
            poster="../assets/images/product/videoBg.jpg"
          ></video>

          <!-- 遮罩层 -->
          <div class="video-overlay"></div>

          <!-- 内容层 -->
          <div class="video-content">
            <img src="../assets/images/product/product_logo.png" class="video-img" />
            <div class="video-text">{{ $t('message.productSystemHint') }}</div>
            <div class="video-name"></div>
          </div>
        </div>

        <div class="productIntroduce" ref="introduceSection">
          <div class="introduce-title">
            {{ $t('message.productSystemDetailTitle') }}
            <!-- <img src="../assets/images/product/product_logo.png" class="introduce-title" style="width:360px;display: inline-block;" /> -->
          </div>

          <div class="introduce-detail" v-if="!isMobile">
            <div>{{ $t('message.productSystemDetailHint1') }}</div>
            <div>{{ $t('message.productSystemDetailHint2') }}</div>
            <div>{{ $t('message.productSystemDetailHint3') }}</div>
            <div>{{ $t('message.productSystemDetailHint4') }}</div>
            <!-- <div>{{ $t('message.productSystemDetailHint5') }}</div> -->

            <!-- <div style="margin-top: 15px;">临床认证高房颤治愈率</div> -->
          </div>

          <div v-if="isMobile" class="introduce-detail">
            <div>{{ $t('message.allproductSystemDetailHint') }}</div>
          </div>

          <!-- 图片 -->
          <div v-if="!isMobile">
            <productPoint ref="productPoint" />
          </div>

          <div v-else class="mobileImage">
            <img src="../assets/images/product/productDetail-mobile.png" />
          </div>
        </div>

        <!-- 动画区域 -->
        <!-- <div ref="wrapper" class="animation-wrapper">
          <produceDetail ref="produceDetail" />
        </div>-->

        <!-- 页面后面内容 操作器和工作站 -->
        <div style="width:100%; margin-top:var( --subtitle--another-font-size);">
          <div class="section-container">
            <!-- 第一行：左文字右图片 -->
            <div class="row row-text-left animate-row">
              <!-- 左侧文字 -->
              <div class="text-content from-left" style="position:relative;top: -10px;left:20vw;;">
                <h2 style="text-align: left;" v-if="!isMobile">{{ $t('message.productSystemRoboticTitle1') }}</h2>
                <h2 style="text-align: left;" v-if="!isMobile">{{ $t('message.productSystemRoboticTitle2') }}</h2>
                <h2
                  style="text-align: left;"
                  v-if="isMobile"
                >{{ $t('message.productSystemRoboticTitle1') }}{{ $t('message.productSystemRoboticTitle2') }}</h2>

                <p style="text-align: left;">{{ $t('message.productSystemRoboticHint1') }}</p>
              </div>
              <!-- 右侧图片 -->
              <div class="image-content image-right from-right">
                <img v-if="!isMobile" src="../assets/images/product/caozuoqi.png" style="position: relative;right: 4vw; max-width:75rem;" />

                <img v-if="isMobile" src="../assets/images/product/caozuo-mobile.png" />
              </div>
            </div>

            <!-- 第二行：左图片右文字 -->
            <div class="row row-text-right animate-row" style="padding: 12vh 0vw;">
              <!-- 左侧图片 -->
              <div class="image-content image-left from-left" style="flex:2;position: relative;left: 15vw;">
                <img src="../assets/images/product/computer.png" style="width:58%;" v-if="!isMobile" />
                <img src="../assets/images/product/computer-mobile.png" style="width:58%;" v-if="isMobile" />
              </div>
              <!-- 右侧文字 -->
              <div class="text-content-right from-right" style="position: relative;right:13vw;">
                <h2 style="text-align: left;" v-if="!isMobile">{{ $t('message.productSystemSWTitle') }}</h2>
                <h2 style="text-align: left;" v-if="!isMobile">{{ $t('message.productSystemSWTitle1') }}</h2>

                <h2
                  style="text-align: left;"
                  v-if="isMobile"
                >{{ $t('message.productSystemSWTitle') }}{{ $t('message.productSystemSWTitle1') }}</h2>

                <p style="text-align: left;">{{ $t('message.productSystemSWHint1') }}</p>
              </div>
            </div>
          </div>
        </div>
        <div style="width:100%;background-color: #F3F8FC;margin-top: var( --subtitle--another-font-size);">
          <div class="caozuo-container">
            <h2 class="caozuo-title">{{ $t('message.productSystemRemoteTitle') }}</h2>
            <p
              class="caozuo-sub"
              v-if="!isMobile"
              style="margin-top:1.9rem !important;"
            >{{ $t('message.productSystemRemoteHint1') }}{{ $t('message.productSystemRemoteHint2') }}{{ $t('message.productSystemRemoteHint3') }}</p>
            <!-- <p class="caozuo-sub" v-if="!isMobile">{{ $t('message.productSystemRemoteHint2') }}</p>
            <p class="caozuo-sub" v-if="!isMobile">{{ $t('message.productSystemRemoteHint3') }}</p>-->

            <p
              class="caozuo-sub"
              v-if="isMobile"
            >{{ $t('message.productSystemRemoteHint1') }}{{ $t('message.productSystemRemoteHint2') }}{{ $t('message.productSystemRemoteHint3') }}</p>

            <!-- <p class="caozuo-sub">{{ $t('message.productSystemRemoteHint4') }}</p> -->

            <div class="caozuo-flex">
              <!-- 左边 -->
              <div class="caozuo-item">
                <img v-if="!isMobile" src="../assets/images/product/shoubing1.png" class="caozuo-img" />
                <img v-if="isMobile" src="../assets/images/product/shoubing1-mobile.png" class="caozuo-img" />
                <div class="caozuo-text">
                  <div class="caozuo-text-title">{{ $t('message.productSystemJoyStick') }}</div>
                  <!-- <div>型号：MTMAN-33511</div> -->
                </div>
              </div>

              <!-- 右边 -->
              <div class="caozuo-item">
                <img v-if="!isMobile" src="../assets/images/product/shoubing.png" class="caozuo-img" />
                <img v-if="isMobile" src="../assets/images/product/shoubing-mobile.png" class="caozuo-img" />
                <div class="caozuo-text">
                  <div class="caozuo-text-title">{{ $t('message.productSystemHandleStyle') }}</div>
                  <!-- <div>型号：MTMAN-101</div> -->
                </div>
              </div>
            </div>
          </div>
        </div>
        <!-- 远程波笛 -->
        <div style="width:100%;background-color: #f5f5f7;">
          <div class="botti-container">
            <div class="botti-header">
              <h2 class="botti-title">{{ $t('message.productBodiTitle') }}</h2>
              <p class="botti-desc" style="margin-top: 1.9rem !important;" v-if="!isMobile">{{ $t('message.productBodiHint1') }}</p>
              <p class="botti-desc" v-if="!isMobile">{{ $t('message.productBodiHint2') }}</p>
              <p class="botti-desc" v-if="isMobile">{{ $t('message.productBodiHint1') }}{{ $t('message.productBodiHint2') }}</p>
            </div>

            <div class="botti-image">
              <!-- PC端 -->
              <div v-if="!isMobile" style="position: relative;">
                <img :src="bottiImg" alt="botti 背景图" />
                <div class="botti-footer">
                  <div>
                    <h2 class="botti-footer-title">{{ $t('message.productBodiFooterTitle') }}</h2>
                    <div class="botti-footer-desc">
                      <div>{{ $t('message.productBodiFooterHint1') }}</div>

                      <div>{{ $t('message.productBodiFooterHint2') }}</div>
                    </div>
                  </div>
                </div>
              </div>

              <!-- 移动端：两张图片 -->
              <div v-else class="botti-image-mobile">
                <div>
                  <img :src="bottiImgMobile1" alt="botti 背景图1" />
                </div>
                <div>
                  <img :src="bottiImgMobile2" alt="botti 背景图2" />
                </div>
                <div class="botti-footer">
                  <div>
                    <h2 class="botti-footer-title">{{ $t('message.productBodiFooterTitle') }}</h2>
                    <div class="botti-footer-desc">
                      <div>{{ $t('message.productBodiFooterHint1') }}</div>

                      <div>{{ $t('message.productBodiFooterHint2') }}</div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
        <div style="width:100%;background-color: #f5f5f7;">
          <!-- 花璐 -->
          <div class="flower-container" ref="flowerContainer">
            <div class="flower-row animate-row">
              <div class="flower-left from-left" ref="flowerLeft">
                <img v-if="!isMobile" src="../assets/images/product/flower.png" />
                <!-- 移动端：两张图片 -->
                <div v-else class="botti-image-mobile">
                  <div>
                    <img src="../assets/images/product/flower-mobile.png" alt="花璐 背景图1" />
                  </div>
                  <div
                    style="    font-size: 1.2rem;
    position: relative;    width: 90%;
    left: 5vw;"
                  >EP Sheath Adapter and Advancement Shaft</div>
                  <div>
                    <img style="position: relative;left: 15%;" src="../assets/images/product/flower-mobile1.png" alt="花璐 背景图2" />
                  </div>
                  <div style="font-size: 1.2rem;position: relative;left: 5vw;     width: 90%;">EP Catheter Adapter and Advancement Shaft</div>
                </div>
              </div>
              <div class="flower-right from-right" ref="flowerRight">
                <h2 v-if="!isMobile">{{ $t('message.productFloraTitle') }}</h2>
                <h2 v-if="!isMobile">{{ $t('message.productFloraTitle1') }}</h2>
                <h2 v-if="isMobile">{{ $t('message.productFloraTitle') }}{{ $t('message.productFloraTitle1') }}</h2>

                <!-- <h2>介入器械控制系统传输部件</h2> -->
                <div class="flower-text">
                  <div class="flower-right-text">{{ $t('message.productFloraHint') }}</div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </template>
    </section>
  </div>
</template>

<script>
import { gsap } from 'gsap'
import { ScrollTrigger } from 'gsap/ScrollTrigger'
// import produceDetail from '@/components/productAnimate.vue'
import productPoint from '@/components/productPoint.vue'

gsap.registerPlugin(ScrollTrigger)

export default {
  components: { productPoint },
  data() {
    return {
      isMobile: window.innerWidth <= 768,
      bottiImg: require('../assets/images/product/botti_bg.png'),
      bottiImgMobile1: require('@/assets/images/product/botti_mobile_m1.png'),
      bottiImgMobile2: require('@/assets/images/product/botti_mobile_m2.png'),
      lastScrollY: 0, // 上一次滚动位置
      scrollDirection: null, // "down" 或 "up"
      lastScrollTime: 0,
      sections: [
        { label: 'TITIAN® ', content: '展示内容', id: 0 },
        { label: 'TITIAN', content: '内容1', id: 1 },
        { label: 'SAN.BOTTI', content: '内容2', id: 2 },
        { label: 'EP FLORA', content: '内容3', id: 3 }
      ],
      activeSection: 1,
      isManualScroll: true, // 新增标志位，默认手动滚动
      wrapperTop: 0,
      wrapperHeight: 0
    }
  },
  mounted() {
    this.$nextTick(() => {
      // 获取 wrapper
      const wrapper = Array.isArray(this.$refs.wrapper) ? this.$refs.wrapper[0] : this.$refs.wrapper
      if (wrapper) {
        this.wrapperTop = wrapper.offsetTop
        this.wrapperHeight = wrapper.offsetHeight
      }

      window.addEventListener('scroll', this.onScroll)
      window.addEventListener('resize', this.onResize)
      this.setAnchorOffset()

      const video = this.$refs.bgVideo
      video.loop = false // 禁止循环播放

      // 当视频播放结束时，保持在最后一帧
      video.addEventListener('ended', () => {
        video.pause()
        video.currentTime = video.duration // 确保停在最后一帧
      })

      const observer = new IntersectionObserver(
        entries => {
          entries.forEach(entry => {
            if (entry.isIntersecting) {
              // 进入可视区域，重新从头播放
              video.currentTime = 0
              video.play()
            } else {
              // 离开可视区域，跳回第一帧
              video.pause()
              video.currentTime = 0
            }
          })
        },
        { threshold: 0.5 } // 50%可视区域触发
      )

      observer.observe(video)

      // video 与 introduce 动画
      const videoTarget = Array.isArray(this.$refs.videoSection) ? this.$refs.videoSection[0] : this.$refs.videoSection
      const introduceTarget = Array.isArray(this.$refs.introduceSection) ? this.$refs.introduceSection[0] : this.$refs.introduceSection

      const videoImg = videoTarget.querySelector('.video-img')
      const videoText = videoTarget.querySelector('.video-text')
      const videoName = videoTarget.querySelector('.video-name')

      const introduceTitle = introduceTarget.querySelector('.introduce-title')
      // const introduceName = introduceTarget.querySelector('.introduce-name')
      const introduceDetail = introduceTarget.querySelector('.introduce-detail')
      // const introduceDetailText1 = introduceTarget.querySelector('.introduce-detail-text1')
      // const introduceDetailText2 = introduceTarget.querySelector('.introduce-detail-text2')

      gsap.set([videoImg, videoText, videoName, introduceTitle, introduceDetail], {
        opacity: 0,
        y: 30
      })

      // IntersectionObserver 视频区域
      const videoObserver = new IntersectionObserver(
        entries => {
          entries.forEach(entry => {
            if (entry.isIntersecting) {
              gsap.to(videoImg, { opacity: 1, y: 0, duration: 0.8, delay: 0.2, ease: 'power3.out' })
              gsap.to(videoText, { opacity: 1, y: 0, duration: 0.8, delay: 1, ease: 'power3.out' })
              gsap.to(videoName, { opacity: 1, y: 0, duration: 0.8, delay: 1.8, ease: 'power3.out' })
            } else {
              gsap.set([videoImg, videoText, videoName], { opacity: 0, y: 30 })
            }
          })
        },
        { threshold: 0.2 }
      )
      videoObserver.observe(videoTarget)

      // IntersectionObserver introduce 区域
      const introduceObserver = new IntersectionObserver(
        entries => {
          entries.forEach(entry => {
            if (entry.isIntersecting) {
              gsap.to(introduceTitle, { opacity: 1, y: 0, duration: 0.8, delay: 0.2, ease: 'power3.out' })
              // gsap.to(introduceName, { opacity: 1, y: 0, duration: 0.8, delay: 1, ease: 'power3.out' })
              gsap.to(introduceDetail, { opacity: 1, y: 0, duration: 0.8, delay: 1, ease: 'power3.out' })
              // gsap.to(introduceDetailText1, { opacity: 1, y: 0, duration: 0.8, delay: 2.6, ease: 'power3.out' })
              // gsap.to(introduceDetailText2, { opacity: 1, y: 0, duration: 0.8, delay: 3.4, ease: 'power3.out' })
            } else {
              gsap.set([introduceTitle, introduceDetail], {
                opacity: 0,
                y: 30
              })
            }
          })
        },
        { threshold: 0.2 }
      )
      introduceObserver.observe(introduceTarget)

      // 初始化容器内每一行
      const containers = document.querySelectorAll('.section-container')

      containers.forEach(container => {
        const rows = container.querySelectorAll('.animate-row')

        rows.forEach(row => {
          const fromLeft = row.querySelector('.from-left')
          const fromRight = row.querySelector('.from-right')

          // 初始化位置
          gsap.set([fromLeft, fromRight], { opacity: 0, y: 120 })

          // 为每行单独创建 Timeline
          const tl = gsap.timeline({ paused: true })
          tl.to([fromLeft, fromRight], { opacity: 1, y: 0, duration: 0.8, ease: 'power3.out' })

          // 每行使用 IntersectionObserver 独立触发
          const rowObserver = new IntersectionObserver(
            entries => {
              entries.forEach(entry => {
                if (entry.isIntersecting) {
                  tl.play()
                } else {
                  gsap.set([fromLeft, fromRight], { opacity: 0, y: 120 })
                  tl.pause(0)
                }
              })
            },
            { threshold: 0.3 } // 进入视口 30% 即触发
          )
          rowObserver.observe(row)
        })
      })

      // 操作区动画
      const caozuoT1 = gsap.timeline({
        scrollTrigger: {
          trigger: '.caozuo-container',
          start: 'top 80%',
          toggleActions: 'restart none none reset'
        }
      })

      // 标题 + 段落
      caozuoT1
        .from('.caozuo-title', { y: 80, opacity: 0, duration: 0.8, ease: 'power3.out' })
        .from('.caozuo-sub', { y: 80, opacity: 0, duration: 0.6, stagger: 0.2, ease: 'power3.out' }, '-=0.4')

      // 左边：图片 → 文字
      caozuoT1
        .from('.caozuo-flex .caozuo-item:nth-child(1) .caozuo-img', { y: 80, opacity: 0, duration: 0.8, ease: 'power3.out' })
        .from('.caozuo-flex .caozuo-item:nth-child(1) .caozuo-text', { y: 80, opacity: 0, duration: 0.6, ease: 'power3.out' }, '-=0.4')

      // 右边：图片 → 文字
      caozuoT1
        .from('.caozuo-flex .caozuo-item:nth-child(2) .caozuo-img', { y: 80, opacity: 0, duration: 0.8, ease: 'power3.out' })
        .from('.caozuo-flex .caozuo-item:nth-child(2) .caozuo-text', { y: 80, opacity: 0, duration: 0.6, ease: 'power3.out' }, '-=0.4')

      // botti 区域动画
      const bottiTl = gsap.timeline({
        scrollTrigger: {
          trigger: '.botti-container',
          start: 'top 80%',
          toggleActions: 'restart none none reset'
        }
      })

      // 标题
      bottiTl.from('.botti-title', {
        y: 50,
        opacity: 0,
        duration: 0.8,
        ease: 'power3.out'
      })

      // 描述文字
      bottiTl.from(
        '.botti-desc',
        {
          y: 30,
          opacity: 0,
          duration: 0.6,
          ease: 'power2.out'
        },
        '-=0.4'
      ) // 与标题重叠一点时间

      // 中间图片
      bottiTl.from(
        '.botti-image img',
        {
          y: 80,
          opacity: 0,
          duration: 1,
          ease: 'power3.out'
        },
        '-=0.2'
      )

      // 底部标题
      bottiTl.from(
        '.botti-footer-title',
        {
          y: 40,
          opacity: 0,
          duration: 0.8,
          ease: 'power3.out'
        },
        '-=0.2'
      )

      // 底部描述
      bottiTl.from(
        '.botti-footer-desc',
        {
          y: 20,
          opacity: 0,
          duration: 0.6,
          ease: 'power2.out'
        },
        '-=0.3'
      )
      this.$nextTick(() => {
        const left = this.$refs.flowerLeft
        const right = this.$refs.flowerRight
        const container = this.$refs.flowerContainer

        if (!left || !right || !container) return

        // 初始位置在下方更低，透明
        gsap.set([left, right], { y: 120, opacity: 0 })

        const tl = gsap.timeline({ paused: true })
        tl.to(left, { y: 0, opacity: 1, duration: 0.8, ease: 'power3.out' }) // 图片从下往上
        tl.to(right, { y: 0, opacity: 1, duration: 0.8, ease: 'power3.out' }, '-=0.5') // 文字从下往上，重叠动画

        const observer = new IntersectionObserver(
          ([entry]) => {
            if (entry.isIntersecting) {
              tl.play()
            } else {
              // 回到初始下方位置
              gsap.set([left, right], { y: 120, opacity: 0 })
              tl.pause(0)
            }
          },
          { threshold: 0.1 }
        )

        observer.observe(container)
      })
    })
  },
  beforeDestroy() {
    window.removeEventListener('scroll', this.onScroll)
    window.removeEventListener('resize', this.onResize)
  },
  methods: {
    onImageClick(e) {
      const rect = this.$refs.introduceProductDetail.getBoundingClientRect()
      const clickX = e.clientX - rect.left
      const clickY = e.clientY - rect.top
      const xPercent = (clickX / rect.width).toFixed(2)
      const yPercent = (clickY / rect.height).toFixed(2)
      console.log(`xPercent: ${xPercent}, yPercent: ${yPercent}`)
    },

    setAnchorOffset() {
      const logoEl = document.querySelector('.navbar-logo')
      const navbar = document.querySelector('.navbar')
      // console.log(navbar.height)
      if (logoEl) {
        const rect = logoEl.getBoundingClientRect()
        this.$refs.anchorNavbar.style.paddingLeft = rect.left - 20 + 'px'
        this.$refs.anchorNavbar.style.top = navbar.offsetHeight + 'px'
        this.$refs.anchorSection.style.marginTop = navbar.offsetHeight + logoEl.offsetHeight + 10 + 'px'
      }
      this.bottiImg =
        window.innerWidth > 1980 ? require('../assets/images/product/botti_big_bg.png') : require('../assets/images/product/botti_bg.png')
      this.isMobile = window.innerWidth <= 768
    },
    onResize() {
      this.$nextTick(() => {
        const wrapper = Array.isArray(this.$refs.wrapper) ? this.$refs.wrapper[0] : this.$refs.wrapper
        if (wrapper) {
          this.wrapperTop = wrapper.offsetTop
          this.wrapperHeight = wrapper.offsetHeight
        }
        this.onScroll()
        this.setAnchorOffset()
      })
    },
    scrollToSection(item) {
      // 标记为程序滚动
      this.isManualScroll = false
      console.log(item)
      if (item.id == 2) {
        const bottiContainer = document.querySelectorAll('.botti-container')[0]
        console.log(bottiContainer.offsetTop)
        window.scrollTo({
          top: bottiContainer.offsetTop - 80,
          behavior: 'smooth'
        })
      } else if (item.id == 1) {
        const videoContainer = document.querySelectorAll('.video')[0]
        console.log(videoContainer.offsetTop)
        window.scrollTo({
          top: videoContainer.offsetTop - 80,
          behavior: 'smooth'
        })
      } else if (item.id == 3) {
        const flowerContainer = document.querySelectorAll('.flower-container')[0]
        console.log(flowerContainer.offsetTop)
        window.scrollTo({
          top: flowerContainer.offsetTop - 80,
          behavior: 'smooth'
        })
      }

      this.activeSection = item.id

      // 在滚动结束后恢复手动滚动标志
      setTimeout(() => {
        this.isManualScroll = true
      }, 800) // 这里的时间可以根据 smooth 滚动时间调整
    },
    onScroll() {
      if (!this.isManualScroll) return // 如果是程序滚动，直接返回

      const now = Date.now()
      if (now - this.lastScrollTime < 50) return
      this.lastScrollTime = now

      const scrollY = window.scrollY

      const viewportHeight = window.innerHeight

      // 判断滚动方向
      if (scrollY > this.lastScrollY) {
        this.scrollDirection = 'down'
      } else if (scrollY < this.lastScrollY) {
        this.scrollDirection = 'up'
      }

      this.lastScrollY = scrollY

      //      const scrollY = window.scrollY
      // const viewportHeight = window.innerHeight

      const section1 = document.querySelector(this.scrollDirection == 'down' ? '.video' : '.caozuo-container') // 1
      const section2 = document.querySelector('.botti-container') // 2
      const section3 = document.querySelector('.flower-container') // 3

      if (section1 && section2 && section3) {
        const s1Top = section1.offsetTop
        const s1Height = section1.offsetHeight
        const s2Top = section2.offsetTop
        const s2Height = section2.offsetHeight
        const s3Top = section3.offsetTop

        // 用窗口中点位置判断
        const scrollMiddle = scrollY + viewportHeight / 2

        if (scrollMiddle >= s1Top && scrollMiddle < s1Top + s1Height) {
          this.activeSection = 1
        } else if (scrollMiddle >= s2Top && scrollMiddle < s2Top + s2Height) {
          this.activeSection = 2
        } else if (scrollMiddle >= s3Top) {
          this.activeSection = 3
        }
      }

      const wrapper = Array.isArray(this.$refs.wrapper) ? this.$refs.wrapper[0] : this.$refs.wrapper
      const produceDetail = Array.isArray(this.$refs.produceDetail) ? this.$refs.produceDetail[0] : this.$refs.produceDetail

      if (!wrapper || !produceDetail) return

      // const triggerPoint = wrapper.offsetTop
      // const wrapperBottom = wrapper.offsetTop + wrapper.offsetHeight

      // if (scrollY < triggerPoint) {
      //   produceDetail.updateByProgress && produceDetail.updateByProgress(0, true)
      // } else if (scrollY >= triggerPoint && scrollY <= wrapperBottom) {
      //   const relativeScroll = scrollY - triggerPoint
      //   const totalHeight = wrapper.offsetHeight - viewportHeight * 0.5
      //   let progress = relativeScroll / totalHeight
      //   progress = Math.min(Math.max(progress, 0), 1)
      //   produceDetail.updateByProgress && produceDetail.updateByProgress(progress)
      // }
    }
  }
}
</script>

<style scoped>
.flower-text {
  margin-top: 1.9rem;
}
.guide {
  position: relative;
  display: inline-block;
}

.bg-img {
  display: block;
  max-width: 100%;
}

.overlay {
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  pointer-events: none; /* 不遮挡交互 */
}

.introduce-product-detail {
  margin-top: 5rem;
}

/* 固定宽度+居中所有主要容器 */

.flower-container {
  /* width: 100vw; */
  margin: 0 auto;
  padding: 12vh 0px;

  /* background-color: #f5f5f7; */
}

.flower-row {
  height: 100%;
  display: flex;
  justify-content: space-between;
  align-items: center;

  background-color: #f5f5f7;
}

.flower-left {
  flex: 2;
  display: flex;
  align-items: center;
  justify-content: flex-start;
  /* padding-top: 100px; */
}

.flower-left img {
  max-width: 70%;
  height: auto;
  -o-object-fit: contain;
  object-fit: contain;
  position: relative;
  left: 12vw;
}

.flower-right {
  width: 40vw;
  color: black;
  text-align: left;
  position: relative;
  right: 16vw;
}

.flower-right h2 {
  margin: 0;
  font-size: var(--title-font-size);
}

.flower-right p {
  margin-top: 3.125rem !important;
  font-size: var(--subtitle-font-size);
  color: black;
}

.botti-container {
  margin-top: var(--subtitle--another-font-size) !important;
  background: #f5f5f7;
}

.botti-header {
  padding: 10vh 18vw 4vh;
  text-align: center;
}

.botti-title {
  margin: 0;
  font-size: var(--title-font-size);
}

.botti-desc {
  /* margin-top: 4px !important; */
  /* font-size: var(--subtitle-font-size); */
  color: black;
  font-size: 1.2rem;
  color: #3d3d3d;
  line-height: 1.7rem;
  font-weight: 400;
}

.botti-image img {
  width: 100%;
  display: block; /* 去掉图片底部空白 */
}

.botti-footer {
  text-align: center;

  position: absolute;
  bottom: 2rem;
  left: 50%;
  transform: translate(-50%, 0%);

  width: 90%;
}

.botti-footer-title {
  margin: 0;
  font-size: var(--title-font-size);
  color: white;
}

.botti-footer-desc {
  margin: 0;
  color: white;
  margin: 1rem 0 2rem 0;
  font-size: 1.2rem;
  line-height: 1.7rem;
  font-weight: 400;
}

.caozuo-container {
  position: relative;
  padding: 12vh 0;
  width: 90%; /* 容器宽度占屏幕的 90% */

  margin: 0 auto;
}
.caozuo-title {
  margin: 0;
  font-size: var(--title-font-size);
}

.caozuo-sub {
  font-size: 1.2rem;
  color: #3d3d3d;
  line-height: 1.7rem;
  font-weight: 400;
  width: 66%;
  margin: 0 auto !important;
}

.caozuo-flex {
  display: flex;
  /* gap: 40px; */
  /* margin-top: 10vh !important; */
  width: 82vw;
  margin: 0 auto;
}

.caozuo-item {
  flex: 1;
  position: relative;
  display: flex;
  flex-direction: column;
  align-items: center;
}

.caozuo-img {
  height: 45vh;
  object-fit: contain;
}

.caozuo-text {
  position: absolute;
  bottom: 5vh;
  text-align: center;
  width: 100%;
  /* font-size:var(--subtitle-font-size); */
}

.caozuo-text-title {
  color: black;

  font-weight: 400;
  font-size: 1.2rem;
}

/* 动画初始状态 */
.from-left {
  opacity: 0;
  /* transform: translateX(-50px); */
}

.from-right {
  opacity: 0;
  /* transform: translateX(50px); */
}

/* 可选：让动画更流畅 */
.animate-row {
  overflow: hidden;
  position: relative;
}
.row-text-right {
  margin-top: var(--subtitle--another-font-size);
}

.section-container {
  display: flex;
  flex-direction: column;
}

.row {
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding: 12vh 0vw;
  background: linear-gradient(55deg, #f5f7f9 0%, #eef5fb 100%);
}

.text-content {
  width: 29vw;
  color: black;
  position: relative;
  top: -10px;
}

.text-content h2 {
  margin: 0;
  font-size: var(--title-font-size);
}

.text-content p {
  /* margin: 5px 0 !important; */
  /* font-size: var(--subtitle-font-size); */
  /* width: 93%; */
  margin-top: 1.9rem !important;
  font-size: 1.2rem;
  color: #3d3d3d;
  line-height: 1.7rem;
  font-weight: 400;
}

.text-content-right {
  width: 37vw;
  color: black;
  position: relative;
  top: -10px;
}

.text-content-right h2 {
  margin: 0;
  font-size: var(--title-font-size);
  /* width:80%; */
}

.text-content-right p {
  width: 80%;
  margin-top: 1.9rem !important;
  font-size: 1.2rem;
  color: #3d3d3d;
  line-height: 1.7rem;
  font-weight: 400;
}

.image-content {
  flex: 3;
  display: flex;
  align-items: center;
}

.image-left {
  justify-content: flex-start;
  /* padding-top: 100px; */
  /* margin-left: 50px; */
}

.image-right {
  justify-content: flex-end;
  /* margin-right: 50px; */
  /* padding-top: 100px; */
}

.image-content img {
  object-fit: contain;
  /* max-width: 1000px; */
  width: 66%;
}

.animation-wrapper {
  position: relative;
  height: auto;
  background-color: black;
}
.productIntroduce {
  /* background-color: black; */
  background: url('@/assets/images/product/allProductBg.png') no-repeat top center;
  background-size: cover;
  position: relative;
  text-align: center;
  padding-top: 9.375rem;
  padding-bottom: var(--subtitle--another-font-size);
}
.introduce-detail {
  margin-top: 1.9rem;
  font-size: 1.2rem;
  color: #3d3d3d;
  line-height: 1.7rem;
  font-weight: 400;
}
.anchor-navbar {
  position: fixed;
  /* top: 60px; */
  width: 100%;
  height: 3.5rem;
  background-color: #111827;
  display: flex;
  align-items: center;
  z-index: 3;
  font-size: var(--header-size);
}
.anchor-list {
  display: flex;
  list-style: none;
  margin: 0;
  padding: 0;
}
.anchor-list li {
  margin: 0 2rem;
  color: #9ca3af;
  cursor: pointer;
  font-weight: 400;
  transition: color 0.3s, border-bottom 0.3s;
  padding-bottom: 4px;
  position: relative;
  letter-spacing: 1px;
}
.anchor-list li:hover {
  color: #00acf8;
}
.anchor-list li::after {
  content: '';
  position: absolute;
  bottom: 0;
  left: 0;
  width: 100%;
  height: 2px;
  background-color: #00acf8;
  transform: scaleX(0);
  transform-origin: center;
  transition: transform 0.3s;
}
.anchor-list li:hover::after {
  transform: scaleX(1);
}
.anchor-list li.display-only {
  cursor: default;
  color: #f9fafb;
}
.anchor-list li.display-only::after {
  display: none;
}
.anchor-list li.active {
  color: #00acf8;
}
.anchor-list li.active::after {
  transform: scaleX(1);
}

.anchor-section {
  /* height: 100vh; */
  /* padding-top: 5rem; */
  text-align: center;
}
.video {
  position: relative;
  width: 100%;
  height: 100vh;
  overflow: hidden;
}

/* 背景视频：全屏居中覆盖 */
.bg-video {
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  object-fit: cover; /* 保持比例，裁切填充满屏 */
  object-position: center; /* 居中对齐 */
  z-index: -2;
}

/* 背景视频：全屏居中覆盖 */
.bg-video-mobile {
  position: absolute;
  bottom: 0px;
  left: 0;
  width: 100%;
  height: auto;
  object-fit: cover; /* 保持比例，裁切填充满屏 */
  object-position: center; /* 居中对齐 */
  z-index: 1;
}

/* 黑色遮罩层 */
.video-overlay {
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background: rgba(0, 0, 0, 0.2); /* 30% 黑色 */
  z-index: -1;
}

/* 内容：水平 + 垂直居中 */
.video-content {
  position: absolute;
  z-index: 10;
  display: flex;
  flex-direction: column;

  height: 100%;
  text-align: center;
  color: white;
  top: 10vh;
  left: 18vw;
  z-index: 2; /* 确保文字在遮罩层上面 */
}

.video-img {
  max-width: 700px;
  width: 300px;
  margin-bottom: var(--subtitle--another-font-size);
}

.video-text {
  font-size: var(--subtitle-font-size);
  margin-bottom: 10px;
  text-align: left;
  color: #adafaf;
  font-weight: 400;
}

.video-name {
  font-size: 22px;
  text-align: left;
  /* font-weight: bolder; */
}

/* 移动端居中显示 */
@media (max-width: 768px) {
  .video {
    position: relative;
    width: 100%;
    height: 50rem;
    overflow: hidden;
    background: #000;
  }

  .anchor-section {
    /* height: 100vh; */
    /* padding-top: 5rem; */
    text-align: center;
  }

  .video-content {
    top: 16%;
    left: 50%;

    transform: translate(-50%, -50%);
    align-items: start;
    justify-content: center;
    text-align: center;
    width: 90%; /* 防止文字贴边 */

    padding: 0 10px;
  }

  .video-img {
    width: 65%; /* 图片自适应 */
    max-width: 300px;
    margin-bottom: 1rem;
  }
}

.introduce-title {
  /* font-family: wix Madefor Display, wix Madefor Display; */
  font-weight: bolder;
  font-size: var(--title-font-size);
  color: black;
  line-height: 43px;
  text-align: left;
  font-style: normal;
  text-transform: none;
  text-align: center;
  /* letter-spacing: 1px; */
}
.flower-right-text {
  width: 90%;
  font-size: 1.2rem;
  color: #3d3d3d;
  line-height: 1.7rem;
  font-weight: 400;
}

/* 移动端居中显示 */
@media (max-width: 768px) {
  .productIntroduce {
    padding-top: 0rem;
  }
  .introduce-detail {
    text-align: left;
    margin-top: 0px;
    padding: 2rem 20px 0;
  }
}

/* 📱 移动端：上下布局（图片在上，文字在下） */
@media (max-width: 768px) {
  .row {
    flex-direction: column; /* 改为垂直方向 */
    align-items: center;
    text-align: center;
    gap: 0px;
    padding: 0px !important;
  }

  .row-img {
    order: 1; /* 图片在上 */
    width: 80%;
    max-width: 300px;
  }

  .row-text {
    order: 2; /* 文字在下 */
    width: 90%;
    font-size: 1rem;
  }
  .text-content {
    width: 98vw;
    left: auto !important;
  }
  .text-content h2 {
    text-align: left !important;
    font-size: 3rem;
    padding: 5rem 20px 0;
  }
  .text-content p {
    width: auto;
    text-align: left !important;
    padding: 2rem 20px 0;
    margin-top: 0rem !important;
  }
  .image-content img {
    margin: 3rem 0px;
    width: 100%;
    position: relative;
    /* left: -7vw; */
  }
  .image-left img {
    width: 100% !important;
    left: 0vw !important;
  }
  .image-left {
    left: 0vw !important;
    order: 2; /* 图片在下 */
    left: 0;
  }

  .text-content-right {
    order: 1; /* 文字在上 */
    right: 0vw !important;
    width: 98vw;
  }
  .text-content-right h2 {
    text-align: left !important;
    font-size: 3rem;
    padding: 5rem 20px 0;
  }
  .text-content-right p {
    width: auto;
    text-align: left !important;
    padding: 2rem 20px 0;
    margin-top: 0rem !important;
  }

  .caozuo-container {
    padding: 0rem 0px !important;
    text-align: left;
    width: 100%;
  }

  @media (max-width: 768px) {
    .caozuo-title {
      margin: 0;
      font-size: 3rem;
      padding: 5rem 20px 0;
    }
    .caozuo-flex {
      flex-direction: column; /* 上下排列 */
      align-items: center;
      gap: 0rem;
      width: 95vw;
      padding-bottom: 3rem;
      padding-top: 3rem;
    }

    .caozuo-item {
      width: 100%;
    }

    .caozuo-img {
      width: 100%;
      height: 30vh;
    }
    .botti-header {
      font-size: 3rem;
      padding: 5rem 20px 0;
      text-align: left;
    }
    .botti-footer {
      position: relative;
      font-size: 3rem;
      padding: 5rem 20px;
      text-align: left;
      background-color: #04284e;
      margin-top: 1rem;
      width: auto;
    }
    .botti-footer-title {
      font-size: 3rem;
    }
    .botti-footer-desc {
      margin-top: 0px;
      padding: 2rem 0px 0;
      margin-bottom: 0px;
    }

    .flower-row {
      flex-direction: column; /* 上下排列 */
      text-align: center;
      gap: 0rem;
    }

    .flower-right {
      order: 1; /* 文字在上 */
      text-align: left;
      width: 90vw;
      right: 0vw;
    }

    .flower-left {
      order: 2; /* 图片在下 */
      margin: 2rem 0 0;
    }

    .flower-container {
      padding: 5rem 20px 0;
      padding-bottom: 5rem;
    }
    .flower-right-text {
      width: 100%;
    }
    .flower-left img {
      width: 100%;
      max-width: 100%;
      left: 0vw !important;
    }

    .caozuo-text {
      bottom: 4vh;
    }

    .introduce-title {
      font-size: 3rem;
      line-height: 3rem;
      text-align: left;
      padding: 5rem 20px 0;
    }
    .mobileImage {
      margin: 3rem 0px;
    }
    .caozuo-sub {
      padding: 2rem 20px 0;
      margin-top: 0rem !important;
      width: auto;
    }
    .botti-desc {
      padding: 2rem 0px 0;
      margin-bottom: 2rem !important;
    }
    .flower-right h2 {
      font-size: 3rem;
      /* word-break: break-all; */
    }
    .flower-row {
      align-items: start;
      margin-bottom: 2rem;
    }
    .flower-text {
      margin-top: 0rem;
      padding: 2rem 0px 0;
      margin-bottom: 0px;
    }
  }
}

@media (min-width: 769px) and (max-width: 1500px) {
  .botti-footer {
    bottom: -1rem;
  }
}
</style>
